/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Routers from "../../router/RouterTypes";
import Cons from "Constant";
import { GetDocList } from "@/api";
import BScroll from "@/components/Bscroll";
import BottomLine from "@/components/BottomLine";
import IM from "@/common/IM";
import Api from "@/api";
import router_types from "../../router/RouterTypes";
export default {
  name: "WorkHome",
  components: {
    BScroll: BScroll,
    BottomLine: BottomLine
  },
  data: function data() {
    return {
      defaultHeaderImg: require("@/assets/icon_yisheng_nan.png"),
      topList: [{
        name: "在线预约",
        imgUrl: require("@/resources/images/home/icon-zxyy@2x.png")
      }, {
        name: "在线问诊",
        imgUrl: require("@/resources/images/home/icon-zxwz@2x.png")
      }, {
        name: "微商城",
        imgUrl: require("@/resources/images/home/icon-wsc@2x.png")
      }],
      botList: [{
        name: "诊所介绍",
        imgUrl: require("@/resources/images/home/icon-zhensuojs@2x.png")
      }, {
        name: "团队介绍",
        imgUrl: require("@/resources/images/home/icon-tuanduijs@2x.png")
      }, {
        name: "项目介绍",
        imgUrl: require("@/resources/images/home/icon-xiangmjs@2x.png")
      }, {
        name: "产品介绍",
        imgUrl: require("@/resources/images/home/icon-chanpjs@2x.png")
      }, {
        name: "科普知识",
        imgUrl: require("@/resources/images/home/icon-kepuzhis@2x.png")
      }],
      docs: [],
      pageNo: 1,
      pageSize: 50,
      loadStatus: "loadmore",
      totalPage: 1
    };
  },
  computed: {
    /** 返回一个合法可用的医生列表 */
    docList: function docList() {
      return this.docs || [];
    },
    loadText: function loadText() {
      var loadStatus = this.loadStatus;

      switch (loadStatus) {
        case 0:
          return "正在加载中";

        case 1:
          return "上拉加载更多";

        case 2:
          return "无更多数据";
      }
    }
  },
  filters: {
    delHtmlTag: function delHtmlTag(str) {
      return str.replace(/<\/?[^>]*>/g, "");
    }
  },
  created: function created() {
    this.fetchDocList();
  },
  mounted: function mounted() {
    sessionStorage.setItem('isInHome', '1');
  },
  methods: {
    scrollEnd: function scrollEnd() {
      if (this.totalPage <= this.pageNo) {
        this.loadStatus = 2;
        return;
      }

      if (!this.noData) {
        // 获取下一页的数据处理
        this.pageNo += 1;
        this.fetchDocList();
      }
    },

    /**
     * 获取医生清单数据
     */
    fetchDocList: function fetchDocList() {
      var _this = this;

      var that = this;
      this.loadStatus = 0;
      Api.om.getDoctorListByHispital({
        pageSize: that.pageSize,
        pageNum: that.pageNo
      }).then(function (data) {
        var docs = data;
        _this.loadStatus = 1;

        if (docs.data.list) {
          var _that$docs;

          (_that$docs = that.docs).push.apply(_that$docs, _toConsumableArray(docs.data.list));

          that.totalPage = docs.data.total;

          if (_this.totalPage <= _this.pageNo) {
            _this.loadStatus = 2;
          } // if (that.pageNo < this.totalPage) {
          //     that.pageNo++;
          // }

        }

        if (docs.data.list && docs.data.list.length == 0) {
          that.pageNo--;
        }

        docs.data.list.forEach(function (v, i, array) {
          v.isShowMore = false;
        });
      }); // 调用20002接口
      // GetDocList({ pageNo: that.pageNo, pageSize: that.pageSize }).then(data => {
      //     // 接口返回数据
      //     let docs = data;
      //     this.loadStatus = 1;
      //     if (docs.dataSource) {
      //         that.docs.push(...docs.dataSource);
      //         that.totalPage = docs.totalPage;
      //         if (this.totalPage <= this.pageNo) {
      //             this.loadStatus = 2;
      //         }
      //         // if (that.pageNo < this.totalPage) {
      //         //     that.pageNo++;
      //         // }
      //     }
      //     if (docs.dataSource && docs.dataSource.length == 0) {
      //         that.pageNo--;
      //     }
      //     docs.dataSource.forEach((v, i, array) => {
      //         v.isShowMore = false;
      //     });
      //     // this.isHideEmptySign = this.emptyFlag(that.docs);
      // });
    },
    topListTab: function topListTab(item, index) {
      var url = "";
      var appId = Utils.getSessionCache(Cons.APPID);
      var clinicId = Utils.getSessionCache(Cons.CLINIC_ID);

      switch (index) {
        case 0:
          this.$router.push({
            name: "ApptRegRegDocList",
            query: {
              clinicId: clinicId,
              appId: appId
            }
          }); // url =
          // 	"apptReg/regDocList?clinicId=a018f483-7002-4baa-ab90-604bb27d721b&appId=wxcc8d66f17c4fa74e";

          break;

        case 1:
          this.goAppointment();
          break;

        case 2:
          this.$router.push({
            name: "MallIndex",
            query: {
              clinicId: clinicId,
              appId: appId
            }
          }); // url =
          // 	"mall?clinicId=a018f483-7002-4baa-ab90-604bb27d721b&appId=wxcc8d66f17c4fa74e";

          break;

        default:
          break;
      } // if (index !== 1) {
      // 	document.title = item.name;
      // 	window.location.href = Cons.SCRM_PATH + url;
      // }

    },
    botListTab: function botListTab(item, index) {
      var url = "";
      var appId = Utils.getSessionCache(Cons.APPID);
      var clinicId = Utils.getSessionCache(Cons.CLINIC_ID);

      switch (index) {
        case 0:
          this.$router.push({
            name: "MiniClinicIntroduce",
            query: {
              clinicId: clinicId,
              appId: appId
            }
          }); // url =
          // 	"miniClinic/introduce?clinicId=a018f483-7002-4baa-ab90-604bb27d721b&appId=wxcc8d66f17c4fa74e";

          break;

        case 1:
          this.$router.push({
            name: "MiniClinicDocList",
            query: {
              clinicId: clinicId,
              appId: appId
            }
          }); // url =
          // 	"miniClinic/docList?clinicId=a018f483-7002-4baa-ab90-604bb27d721b&appId=wxcc8d66f17c4fa74e";

          break;

        case 2:
          this.$router.push({
            name: "MiniClinicSpecialItemList",
            query: {
              clinicId: clinicId,
              appId: appId
            }
          }); // url =
          // 	"miniClinic/specialItemList?clinicId=a018f483-7002-4baa-ab90-604bb27d721b&appId=wxcc8d66f17c4fa74e";

          break;

        case 3:
          this.$router.push({
            name: "MiniClinicProductList",
            query: {
              clinicId: clinicId,
              appId: appId
            }
          }); // url =
          // 	"miniClinic/productList?clinicId=a018f483-7002-4baa-ab90-604bb27d721b&appId=wxcc8d66f17c4fa74e";

          break;

        case 4:
          this.$router.push({
            name: "MiniClinicScienceArticles",
            query: {
              clinicId: clinicId,
              appId: appId
            }
          }); // url =
          // 	"miniClinic/scienceArticles?clinicId=a018f483-7002-4baa-ab90-604bb27d721b&appId=wxcc8d66f17c4fa74e";

          break;

        default:
          break;
      } // document.title = item.name;
      // window.location.href = Cons.SCRM_PATH + url;

    },
    goDoctorIndex: function goDoctorIndex(item) {
      this.$router.push({
        name: router_types.DCOTOR_INDEX,
        query: {
          doctorId: item.doctorId
        }
      })["catch"](function (err) {
        console.log(err);
      });
    },
    wxLogin: function wxLogin() {
      window.postMessage({
        fullScreen: true
      }, "*");
    },
    // 跳转医生下可是列表
    goAppointment: function goAppointment() {
      this.$router.push({
        name: Routers.DEPTMENT_DCOTOR
      })["catch"](function (err) {
        console.log(err);
      });
    }
  },
  destroyed: function destroyed() {}
};